module.exports = __webpack_public_path__ + "media/images/icon__link@2x-8452b558401b5e36168f4caed582bc0a.png";